import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from "recharts";
import { ArticleCategories } from "../components/ArticleCategories";

export function ArticleDetailPage({
  articleId,
  detail
}: {
  articleId: string;
  detail: {
    article: { title?: string; author?: string; categories?: string[]; article_url?: string; canonical_url?: string } | null;
    daily: Array<{ view_date: string; views: number; unique_visitors: number }>;
  } | null;
}) {
  return (
    <div className="page-stack">
      <div className="toolbar-row">
        <h2>{detail?.article?.title ?? `文章 ${articleId}`}</h2>
        {detail?.article?.article_url || detail?.article?.canonical_url ? (
          <a
            className="text-link"
            href={detail.article.article_url || detail.article.canonical_url}
            target="_blank"
            rel="noreferrer"
          >
            開啟原文
          </a>
        ) : null}
      </div>
      <section className="panel">
        <div className="panel-heading">
          <div>
            <h3>單篇趨勢</h3>
            <ArticleCategories categories={detail?.article?.categories} />
          </div>
          <span>{detail?.article?.author ?? "Unknown"}</span>
        </div>
        <ResponsiveContainer width="100%" height={340}>
          <LineChart data={detail?.daily ?? []}>
            <CartesianGrid stroke="#e5e7eb" />
            <XAxis dataKey="view_date" />
            <YAxis width={64} />
            <Tooltip />
            <Line dataKey="views" name="觀看" stroke="#067a7a" strokeWidth={2} dot={false} />
            <Line dataKey="unique_visitors" name="訪客" stroke="#b45309" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </section>
    </div>
  );
}
